import React, { useState } from 'react';
import styled from 'styled-components';

interface Props {
  alt?: string;
  imgProps?: Record<string, unknown>;
  diameter?: number;
  profileLink: string;
  src: string;
  fallbackSrc?: string;
  // component?: React.Component;
  wrapperStyle?: Record<string, unknown>;
}

const Avatar = ({
  alt = '',
  imgProps = {},
  diameter = 60,
  profileLink,
  src,
  fallbackSrc = '/images/default_profile_pic.png',
  wrapperStyle = {},
}: Props) => {
  const [hasError, setHasError] = useState(false);
  return (
    <AvatarWrapper data-testid="avatar-wrapper" style={{ width: diameter, height: diameter, ...wrapperStyle }}>
      {profileLink ? (
        <a href={profileLink} data-testid="avatar-link" rel="nofollow">
          <AvatarImage
            onError={() => {
              setHasError(true);
            }}
            src={hasError && fallbackSrc ? fallbackSrc : src}
            alt={alt}
            style={{ width: diameter, height: diameter }}
            {...imgProps}
          />
        </a>
      ) : (
        <AvatarImage
          onError={() => {
            setHasError(true);
          }}
          src={hasError && fallbackSrc ? fallbackSrc : src}
          alt={alt}
          style={{ width: diameter, height: diameter }}
          {...imgProps}
        />
      )}
    </AvatarWrapper>
  );
};

export default Avatar;

export const AvatarWrapper = styled.div`
  border-radius: 50%;
  background: #dbdfe5;
`;

const AvatarImage = styled.img`
  border-radius: 50%;
`;
